import React from "react";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  let pathnames = location.pathname.split("/").filter(Boolean);

  // Remove numeric or UUID-like segments (IDs) from the end
  if (pathnames.length > 0) {
    const last = pathnames[pathnames.length - 1];
    if (/^\d+$/.test(last) || /^[0-9a-fA-F-]{8,}$/.test(last)) {
      pathnames = pathnames.slice(0, -1);
    }
  }

  const formatSegment = (segment) => {
    return segment
      .replace(/-/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const handleBack = () => {
    if (pathnames.length > 0) window.history.back();
  };
  const to = `/${pathnames.slice(0, 0 + 1).join("/")}`;

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
      <h6 className="fw-semibold mb-0" style={{ textTransform: "capitalize" }}>
        <span
          style={{ cursor: "pointer", display: "inline" }}
          onClick={handleBack}
        >
          <Icon icon="solar:arrow-left-linear" />
        </span>{" "}
        {pathnames.length > 0
          ? formatSegment(pathnames[pathnames.length - 1])
          : "Dashboard"}
      </h6>

      <ul className="d-flex align-items-center gap-2">
        <li className="fw-medium">
          <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
            Dashboard
          </Link>
        </li>

        {pathnames.map((value, index) => {
          
          const isLast = index === pathnames.length - 1;
          

          return (
            <React.Fragment key={to}>
              <li>-</li>
              <li className="fw-medium" style={{ textTransform: "capitalize" }}>
                {isLast ? (
                  <span>{formatSegment(value)}</span>
                ) : (
                  <Link to={to} className="hover-text-primary">
                    {formatSegment(value)}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default Breadcrumb;
